import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b813aca")

_pushScopeId("data-v-8b813aca")
const _hoisted_1 = { class: "scrollable-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
    width: "1600px",
    "before-close": _ctx.onCancel
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        "label-width": "100px",
        "label-position": "right"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "应用类型:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.applicationTypeName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "操作人:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.operator), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "帐号类型:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.operatorTypeName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "所属企业:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.companyName || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "操作时间:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.operatorTime), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "IP:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.ip), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "响应状态:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.responseStateMsgName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "接口地址:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.requestUri), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "请求参数:" }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_1, [
                        _createVNode("pre", null, _toDisplayString(_ctx.formatJsonString(_ctx.formdata.requestBody)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})